// 直播管理路由
export default {
    path: 'live',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '直播管理'},
    children: [{
        path: 'theme',
        component: () => import('@/components/RouterView'),
        redirect: '/live/theme/list',
        meta: { title: '直播主题'},
        children: [{
            path: 'list',
            component: () => import('@/views/live/theme/list.vue'),
            meta: {title: '主题列表'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/live/theme/edit.vue'),
            meta: {title: '编辑主题'},
            props:true
        },{
            path:'add',
            component: () => import('@/views/live/theme/edit.vue'),
            meta: {title: '新增主题'},
        }]
    },{
        path: 'event',
        component: () => import('@/components/RouterView'),
        redirect: '/live/event/list',
        meta: { title: '直播事件'},
        children: [{
            path: 'list',
            component: () => import('@/views/live/event/list.vue'),
            meta: {title: '直播事件列表'}
        }]
    },{
        path: 'room',
        component: () => import('@/components/RouterView'),
        redirect: '/live/room/list',
        meta: { title: '房间节目'},
        children: [{
            path: 'list',
            component: () => import('@/views/live/room/list.vue'),
            meta: {title: '房间节目列表'}
        }]
    }]
}